import { render, staticRenderFns } from "./MdtInfoCard.vue?vue&type=template&id=2bb9f89a&scoped=true"
import script from "./MdtInfoCard.vue?vue&type=script&lang=js"
export * from "./MdtInfoCard.vue?vue&type=script&lang=js"
import style0 from "./MdtInfoCard.vue?vue&type=style&index=0&id=2bb9f89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9f89a",
  null
  
)

export default component.exports